<script setup lang="ts">
// PROPS
const { salesContact } = defineProps({
    salesContact: { type: Object as PropType<SalesContact>, required: true },
});

// EMITS
defineEmits<{
    openContactForm: [];
}>();
</script>

<template>
    <div class="absolute right-2 bottom-full mb-4 flex flex-col gap-2 lg:hidden">
        <SdpSalesContactWhatsappButton :sales-contact="salesContact" class="drop-shadow-xl" />
        <SdpSalesContactContactFormButton :sales-contact="salesContact" class="drop-shadow-xl" @click="$emit('openContactForm')" />
    </div>
</template>
